import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core';
import { GridGalleryComponent } from '../grid-gallery/grid-gallery.component';

@Component({
  selector: 'app-album-tabs',
  templateUrl: './album-tabs.component.html',
  styleUrls: ['./album-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class AlbumTabsComponent implements OnInit {
  @ViewChild(GridGalleryComponent)
  private gridComponent!: GridGalleryComponent;
  @Input() arrayImages!: any;
  @Input() isAnnonymous!: any;
  @Input() totalImages!: any;
  loginUserDetail: any;
  loaded = false;
  album: any = [];
  limit = 51;
  selectedAlbum: any;

  imageLoading = new Array(10).fill(0).map(() => ({ isLoaded: false }));
  galleryLength = 0;
  singleSelected = false;

  showImageLoading = false;
  dialogData: any = 0;


  currentPicture: any = 0;

  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef;

  constructor(
    private bar: MatSnackBar,
    private aRoute: ActivatedRoute,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {

    this.aRoute.params.subscribe((res: any) => {
      if (res.id) {
        this.dialogData = res.id;
      }
    });
  }

  identify(index: any, item: any) {
    return item.id;
  }

  ngOnInit() {
    this.galleryLength = 0;
    // console.log(this.arrayImages); //__CONSOLE_LOG__

  }

  enableCheckBox() {
    // console.log("album tabs"); //__CONSOLE_LOG__
    this.gridComponent.enableCheckBox();
  }

  uncheckAll(){
    this.gridComponent.UncheckAll();
  }

  zoomActive(event: any) {
  }

  downloadItems(eventName:any) {
    this.gridComponent.downloadSelected(eventName);
  }
  getSelectedItems() {
    this.gridComponent.getSelectedItems();
  }

  selectAll() {
    this.gridComponent.selectAll();
  }

  scrollToItem() {
    this.singleSelected = !this.singleSelected;
    setTimeout(() => {
      const element = document.getElementById(this.currentPicture);
      element?.scrollIntoView({ behavior: 'smooth' });
    }, 500);
  }


  scrollToTop(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

  close() {
    this.router.navigateByUrl("/dashboard/people");
  }

}


